import angular from 'angular';

angular.module('core.tapcolors.constants', [])
    .constant('$TapColorsEvents', {
        FORCE_CLOSE: '$TapColorsEvents:FORCE_CLOSE',
        UPDATE_COLOR: '$TapColorsEvents:UPDATE_COLOR'
    });